import { render, staticRenderFns } from "./TratamentoTaxas.vue?vue&type=template&id=74c221a6"
import script from "./TratamentoTaxas.vue?vue&type=script&lang=js"
export * from "./TratamentoTaxas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports